import React from 'react'

const CoreWorks = () => {
    return (
        <section>
            <div className="container">
                <div className="text-center mb-5">
                    <div className="medium font__size--14 text__14-1024 btn__tag mb-3">Results</div>

                    <h2 className="medium font__size--32 text__40-1024 text__40-md text__40-mm">“From confusion to confidence — ” <br /> My clients transform their health and lifestyle <br />  after reading my books and Follow up with me!</h2>
                </div>

                <div className="row justify-content-center">
                    <div className="col-lg-11 col-xl-9">
                        <div className="row wrapper__wrap-info">
                            <div className="items col-md-4">
                                <img src="./../images/bef(1).png" className="mb-4" alt="" />
                                <h5 className="medium font__size--20 text__20-1024">Commitment</h5>
                                <p className="normal font__size--16 text__16-1024 color__gray-2">“Read, Consistency, transform — my clients see real results, inside and out!”.</p>
                            </div>
                            <div className="items bg__blue col-md-4">
                                <img src="./../images/bef(2).png" className="mb-4" alt="" />
                                <h5 className="medium font__size--20 text__20-1024 color__white">Motivation</h5>
                                <p className="normal font__size--16 text__16-1024 color__gray-1">“From day one to a healthier you — my clients thrive after my guidance.”.</p>
                            </div>
                            <div className="items col-md-4">
                                <img src="./../images/bef(3).png" className="mb-4" alt="" />
                                <h5 className="medium font__size--20 text__20-1024">Passion</h5>
                                <p className="normal font__size--16 text__16-1024 color__gray-2 mb-4">“Books + Commitment = real transformations. See the results for yourself!”.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CoreWorks